import { SR_API_ACTION_USER_PARTNER_APP_INSTALLED } from 'api/actionTypes';

export default async function partnerAppInstalled({ state, apiClient }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_USER_PARTNER_APP_INSTALLED,
    state: state,
    onSuccess() {
      state.set(['currentUser', 'partnerAppInstalled'], true);
    },
  });
}
